import { CountriesMap, Country, ELegalsViews, IArticle } from '../types';
import * as ActionTypes from './actionTypes';

export interface IAppState {
  // i18next is started
  translations: boolean;
  ready: boolean;
  articles: IArticle[];
  error: string;
  view: ELegalsViews;
  countries: CountriesMap;
  mostCommon: Country[];
}

export const initialState: IAppState = {
  translations: false,
  ready: false,
  articles: [],
  error: '',
  view: ELegalsViews.SelectCountry,
  countries: {},
  mostCommon: [],
};

export const statePropName = 'legals';

export default function appReducer(state: IAppState = initialState, action: ActionTypes.ILegalsAppActions): IAppState {
  switch (action.type) {
    case ActionTypes.TRANSLATIONS_READY: {
      return {
        ...state,
        translations: true,
      };
    }
    case ActionTypes.LEGALS_COUNTRIES_UPDATE: {
      const { countries, mostCommon } = action;
      return {
        ...state,
        countries,
        mostCommon,
        ready: true,
      };
    }
    case ActionTypes.LEGALS_REQUEST: {
      return {
        ...state,
        ready: false,
        articles: [],
      };
    }
    case ActionTypes.LEGALS_LOADED: {
      return {
        ...state,
        articles: [...action.articles],
        view: ELegalsViews.Articles,
        ready: true,
      };
    }
    case ActionTypes.LEGALS_FAILED: {
      const error = action.message;
      return {
        ...state,
        error,
        ready: true,
      };
    }
  }
  return state;
}
